<template>
    <div class="dropdown square">
        <div class="dropdown-select" @click="selecting = !selecting">
            <span>
                {{ selectedElements.length }} {{ title
                }}{{ selectedElements.length == 1 ? "" : "s" }}
                selected
            </span>
        </div>
        <div class="dropdown-menu" :class="{ show: selecting }">
            <div
                class="d-flex justify-content-between px-2"
                v-for="(element, index) in elements"
                :key="element"
            >
                <label :for="'ht' + title + index">{{
                    labelizeGeneral(element)
                }}</label>
                <input
                    name="selectedElements"
                    type="checkbox"
                    v-model="selectedElements"
                    :value="element"
                    :id="'ht' + title + index"
                />
            </div>
            <div class="text-right py-2">
                <button class="btn btn-primary w-50" @click="selecting = false">
                    OK
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "hashtag"
        },
        elements: Array,
        initialSelected: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            selecting: false,
            selectedElements: []
        };
    },
    watch: {
        selectedElements(newVal, oldVal) {
            this.$emit("input", newVal);
        }
    },
    mounted() {
        if (this.initialSelected) {
            this.selectedElements = this.initialSelected;  
        }
    }
};
</script>
